import React from "react";

const Coverage = ({ data, summary: isSummary }) => {
  if (isSummary) {
    return null;
  }

  return (
    <section>
      <h3>Coverage</h3>
      <div>
        <div>
          <h4>Plan Name</h4>
        </div>
        <div>
          <h4>Insurance ID</h4>
        </div>
        <div>
          <h4>Payer</h4>
        </div>
      </div>

      {data.map((id, index) => {
        return (
          <div key={index}>
            <div>
              <div>{id.system ? id.system.split("|")[0] : "-"}</div>
            </div>
            <div>
              <div>{id.value ? id.value.split("|")[1] : "-"}</div>
            </div>
            <div>
              <div>
                {id.system ? id.system.split("|")[1] : "-"}{" "}
                <i>({id.value ? id.value.split("|")[0] : "-"})</i>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Coverage;
